export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-regular-0d4ef263e6408a0eebaa186f8573967f.woff";